var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"}));
}

Star.defaultProps = {"width":"48","height":"48","viewBox":"0 0 24 24","fill":"none","stroke":"#000","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Star;

Star.default = Star;
